import { round } from 'lodash';
import { TYPE_OF_SPACES } from '../utils/Constants';

export const sqmCalculationForNonStandardSpaces = (
  sqmNumber: number,
  place: TYPE_OF_SPACES.GARDEN | TYPE_OF_SPACES.BALCONY | TYPE_OF_SPACES.TERRACE
) => {
  const factor: number =
    place === TYPE_OF_SPACES.GARDEN
      ? 0.1
      : place === TYPE_OF_SPACES.BALCONY
      ? 0.5
      : place === TYPE_OF_SPACES.TERRACE
      ? 0.25
      : 0;

  const result: SqmCalculation = {
    total: round(sqmNumber * factor, 1),
    sqmNumber,
    factor,
  };

  return result;
};

export const calculateOutdoorTotal = (apartment: Apartment) => {
  const outdoorKeys: (keyof OutdoorSpaces)[] = ['garden', 'balcony', 'terrace'];

  return outdoorKeys.reduce((sum, key) => {
    const value = apartment[key]?.total;
    return typeof value === 'number' ? sum + value : sum;
  }, 0);
};

export const calculateIndoorTotal = (apartment: Apartment) => {
  const indoorKeys: (keyof IndoorSpaces)[] = [
    'entrance',
    'kitchen',
    'livingRoom',
    'hallway',
    'foyer',
    'roomOne',
    'roomTwo',
    'roomThree',
    'bathroom',
    'wc',
    'storageRoom',
  ];

  return indoorKeys.reduce((sum, key) => {
    const value = apartment[key];
    return typeof value === 'number' ? sum + value : sum;
  }, 0);
};
